import React from 'react'
import { Content, Box, Input, Leggend, BoxSeparator } from './styled'
import { Grid, useMediaQuery, Typography } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { array, string, bool } from 'prop-types'

const Shipping = props => {
  const isMobile = useMediaQuery('(max-width:600px)')

  return (
    <Content>
      <Box>
        {!!props.errorMessage && (
          <Alert style={{ marginBottom: '10px' }} severity='error'>{props.errorMessage}</Alert>
        )}
        <BoxSeparator as={Grid} container>
          <Grid item xs={12}>
            <Typography style={{ fontWeight: 'bold' }} variant={isMobile ? 'subtitle1' : 'h6'}>Información de contacto</Typography>
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingRight: isMobile ? '0px' : '10px' }}>
            <Input size={isMobile ? 'small' : 'medium'} {...props} name='name' placeholder='Nombre' maxlength={50} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Input size={isMobile ? 'small' : 'medium'} {...props} name='lastname' placeholder='Apellidos' maxlength={50} />
          </Grid>
          <Input size={isMobile ? 'small' : 'medium'} {...props} name='date' placeholder={`Fecha de nacimiento ${isMobile ? '' : '(dd/mm/yyyy)'}`} maxlength={70} />
          <Input size={isMobile ? 'small' : 'medium'} {...props} name='email' placeholder='Correo electrónico' maxlength={70} />
          {!props.doAdressAexist && (
            <Input size={isMobile ? 'small' : 'medium'} {...props} name='number' placeholder='Tel./cel.' filter='number' maxlength={10} />
          )}
        </BoxSeparator>
        {props.doAdressAexist && (
          <BoxSeparator container as={Grid}>
            <Grid item xs={12}>
              <Typography style={{ fontWeight: 'bold' }} variant={isMobile ? 'subtitle1' : 'h6'}>Dirección</Typography>
            </Grid>
            <Input size={isMobile ? 'small' : 'medium'} {...props} name='street_number' placeholder='Calle y número' maxlength={100} />
            <Input size={isMobile ? 'small' : 'medium'} {...props} name='suburb' placeholder='Colonia' maxlength={50} />
            <Input size={isMobile ? 'small' : 'medium'} {...props} name='city' placeholder='Ciudad' maxlength={50} />
            <Grid item xs={6} style={{ paddingRight: '10px' }}>
              <Input size={isMobile ? 'small' : 'medium'} {...props} name='state' placeholder='Estado' maxlength={50} />
            </Grid>
            <Grid item xs={6}>
              <Input size={isMobile ? 'small' : 'medium'} {...props} name='postal_code' placeholder='Código Postal' filter='number' maxlength={5} />
            </Grid>
            <Input size={isMobile ? 'small' : 'medium'} {...props} name='number' placeholder='Tel./cel.' filter='number' maxlength={10} />
            <Leggend>En caso de que tengamos que contactarte sobre tu pedido</Leggend>
          </BoxSeparator>
        )}

      </Box>
    </Content>
  )
}

Shipping.propTypes = {
  errors: array,
  errorMessage: string,
  doAdressAexist: bool
}

export default Shipping
